export default __webpack_public_path__ + "media/images/ui-icons_228ef1_256x240-a9245423a8c7bdeef75e74afb9aa4f2e.png";